<template>
  <div>
    <a-drawer :title="`${actType}锚点`" :width="850" :visible="showCreateForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form"  :model="anchorModel" :rules="rules" >

        <a-spin :spinning="loading" tip="Loading..." size="large">
        <a-form-model-item label="样式" prop="anchor_type" help='主要适用于投放应用下载、小程序、快应用的客户'>
          <a-select  :default-value="anchorModel.anchor_type" v-model="anchorModel.anchor_type" disabled>
              <a-select-option :value="item.type" v-for="item in anchorTypes" :key="item.type">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="推广内容" prop="net_service_type">
          <a-select  :default-value="anchorModel.net_service_type" v-model="anchorModel.net_service_type" disabled>
              <a-select-option :value="item.type" v-for="item in netServiceTypes" :key="item.type">
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>


        <a-form-model-item label="工具名称" prop="name" help='名称用于您自己管理组件，不会对外显示' style="padding-bottom:20px">
          <!-- <a-input v-model="anchorModel.name" placeholder="最多输入15个字" :maxLength="15"/> -->

          <a-row type="flex"  v-for="(item, key) in advertisers" :key="key" >
            <a-col flex="200px"> {{ item.advertiser_name }}</a-col>
            <a-col flex="auto">
              <a-input v-model="advertisers[key].title" placeholder="最多输入15个字" :maxLength="15"/>
            </a-col>
          </a-row>
         
        </a-form-model-item>


        <a-form-model-item v-if="advertisersSelect.length > 0" label=""  help='' style="border: 1px solid #87e8de;;padding:20px">
          <b style="color:red">以下广告主有多资产，需要确认</b>
          <a-tabs :default-active-key="0" @change="clickPane" size="small" tabPosition="left"  :style="{ height: '500px' }">

            <a-tab-pane  :tab="advertiser.advertiser_name" v-for="(advertiser,index) in advertisersSelect" :key="index" >
              
              <a-form-model-item label="巨量引擎广告主ID">
                 <a-input v-model="advertisers[advertiser.index].advertiser_id" disabled />
              </a-form-model-item> 
              
              <a-form-model-item label="微信小程序资产ID">
                <a-select v-model="advertisers[advertiser.index].instance_id" placeholder="请选择小程序资产" @change="changeApp">
                  <a-select-option :value="item.instance_id" v-for="item in advertiser.apps" :key="item.id" :app="item" :index="advertiser.index">
                    {{ item.name }} - {{ item.create_time }}
                  </a-select-option>
                 </a-select>

                <a-card v-if="advertisers[advertiser.index].appShow.id" size="small" :title="advertisers[advertiser.index].appShow.name" style="background:#ECECEC">
                  <p>小程序资产ID：{{advertisers[advertiser.index].appShow.instance_id}}</p>
                  <p>原始ID：{{advertisers[advertiser.index].appShow.user_name}}</p>
                  <p>路径参数：{{advertisers[advertiser.index].appShow.path}}</p>
                </a-card>

              </a-form-model-item>

              <a-form-model-item label="小程序路径参数" v-if="advertisers[advertiser.index].instance_id">
                 <a-input v-model="advertisers[advertiser.index].path" />
              </a-form-model-item>
             
            </a-tab-pane>

          </a-tabs>
      </a-form-model-item>


        <a-form-model-item label="iOS锚点入口标题字段" prop="ios_anchor_title" help='请输入与iOS端应用名称相关的引导文案'>
          <a-input v-model="anchorModel.ios_anchor_title" placeholder="最多输入12个字" :maxLength="12" />
        </a-form-model-item>
        <a-form-model-item label="安卓锚点入口标题字段" prop="android_anchor_title" help='请输入与安卓端应用名称相关的引导文案'>
          <a-input v-model="anchorModel.android_anchor_title" placeholder="最多输入12个字" :maxLength="12"/>
        </a-form-model-item>

        <a-form-model-item label="应用icon" prop="icon_image" help='请上传应用icon图，比例1:1，大小不超过1M'>
          <material-select v-model="icon_image" :filters="{type:2,num:1,ratio:1,size:1}" :returnData="icon_image"/>
        </a-form-model-item>

        <a-spin :spinning="loading" tip="Loading..." size="large">
        <a-form-model-item label="APP标签">
          <a-input v-model="anchorModel.app_tags[0]" placeholder="最多输入4个字，可空" :maxLength="4"/>
          <a-input v-model="anchorModel.app_tags[1]" placeholder="最多输入4个字，可空" :maxLength="4"/>
          <a-input v-model="anchorModel.app_tags[2]" placeholder="最多输入4个字，可空" :maxLength="4"/>
        </a-form-model-item>

        <a-form-model-item label="引导文案" prop="guide_text" help='仅支持中英文'>
          <a-input v-model="anchorModel.guide_text" placeholder="最多输入15个字" :maxLength="15"/>
        </a-form-model-item>

         
        <a-form-model-item label="图片展示比例" prop="anchor_image_mode" >
            <a-radio-group :v-model="anchor_image_mode" :default-value="anchor_image_mode" @change="imageModeChange" >
              <a-radio-button :value="100">
                横图(2:1)
              </a-radio-button>
              <a-radio-button :value="200">
                竖图(3:5)
              </a-radio-button>
            </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="APP图片" prop="app_images" :help='appImagesHelp'>
          <a-row v-if="anchor_image_mode == 100">
            <a-col :span="6">
              <material-select v-model="appImg1" :filters="appImagesFilters"/>
            </a-col>
           <a-col :span="6">
              <material-select v-model="appImg2" :filters="appImagesFilters"/>
            </a-col>
            <a-col :span="6">
              <material-select v-model="appImg3" :filters="appImagesFilters"/>
            </a-col> 
          </a-row>
          <a-row v-else>
            <a-col :span="6">
              <material-select v-model="appImg4" :filters="appImagesFilters"/>
            </a-col>
           <a-col :span="6">
              <material-select v-model="appImg5" :filters="appImagesFilters"/>
            </a-col>
            <a-col :span="6">
              <material-select v-model="appImg6" :filters="appImagesFilters"/>
            </a-col> 
          </a-row>
        </a-form-model-item>
        

        <a-form-model-item label="APP详情" prop="app_description" help='请详细介绍APP内容与亮点' >
          <a-textarea v-model="anchorModel.app_description" placeholder="最多输入200个字" :auto-size="{ minRows: 3, maxRows: 5 }" :maxLength="200"/>
        </a-form-model-item>

        <div class="result" v-if="result.success.length + result.errors.length > 0">
          <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
          <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
        </div>
      </a-spin>
      </a-spin>
      </a-form-model>

      <div v-if="showSubmit" :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


      <a-modal :visible="showResult" :footer="null" @cancel="closerResult"  centered :title="`批量创建锚点结果`" :width="'50%'">
          <div style="min-height:300px">
            <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
            <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
          </div>
      </a-modal>

    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
